module.exports = __webpack_public_path__ + "img/1.eee86b4f.png";